var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009393",
    d: "m12 20.143l-8.57-8.456L6.7 6.429h10.603l3.27 5.258zm.857-7.714v-1.046c1.543.077 2.983.377 3.429.767c-.519.454-2.374.784-4.286.784s-3.767-.33-4.286-.784c.442-.39 1.886-.686 3.429-.771v1.05zm-5.143-.283v.63c.442.39 1.882.686 3.429.771v2.31h1.714v-2.314c1.543-.077 2.987-.377 3.429-.767V11.52c-.442-.39-1.886-.69-3.429-.771v-.892h2.572V8.572H8.572v1.285h2.571v.892c-1.547.081-2.987.381-3.429.771z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.0257732288f797cacbcac08bafdc2302.svg";
export { ForwardRef as ReactComponent };